import { render, staticRenderFns } from "./AddTask.vue?vue&type=template&id=2b073fd7&"
import script from "./AddTask.vue?vue&type=script&lang=js&"
export * from "./AddTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports